import styled from '@emotion/styled';
import { Autocomplete as MuiAutocomplete } from '@mui/material';
import { theme } from '../../constants/theme';

/**
 * Styled CustomSelect Component using Emotion
 */
export const StyledCustomSelect = styled(MuiAutocomplete)`
  width: 100%;

  .MuiOutlinedInput-root {
    min-height: ${theme.components.input.height};
    border-radius: ${theme.borderRadius.sm};
    font-family: ${theme.typography.fontFamily};
    font-size: ${theme.components.input.fontSize};
    padding: 0 !important;
    background-color: ${theme.colors.background.default};

    fieldset {
      border-color: ${theme.components.input.borderColor};
      border-width: ${theme.components.input.borderWidth};
    }

    &:hover fieldset {
      border-color: ${theme.colors.gray[600]};
    }

    &.Mui-focused fieldset {
      border-color: ${theme.colors.primary.main};
      border-width: 2px;
    }

    &.Mui-error fieldset {
      border-color: ${theme.colors.error.main};
    }

    &.Mui-disabled {
      background-color: ${theme.colors.gray[100]};
      
      fieldset {
        border-color: ${theme.colors.gray[300]};
      }
    }

    input {
      padding: 0 0.75rem !important;
      font-size: ${theme.components.input.fontSize};
      height: auto !important;

      &::placeholder {
        color: ${theme.colors.text.disabled};
        opacity: 1;
      }
    }

    .MuiAutocomplete-input {
      padding: 0 0.75rem !important;
    }
  }

  .MuiInputLabel-root {
    font-size: ${theme.typography.fontSize.sm};
    color: ${theme.colors.text.secondary};
    font-family: ${theme.typography.fontFamily};
    font-weight: ${theme.typography.fontWeight.normal};
    transform: translate(14px, -9px) scale(1);
    background-color: ${theme.colors.background.default};
    padding: 0 4px;

    &.Mui-focused {
      color: ${theme.colors.primary.main};
    }

    &.Mui-error {
      color: ${theme.colors.error.main};
    }
  }

  .MuiAutocomplete-option {
    font-size: ${theme.typography.fontSize.base};
    padding: 0.5rem 1rem;
    font-family: ${theme.typography.fontFamily};

    &:hover {
      background-color: ${theme.colors.gray[100]};
    }

    &[aria-selected="true"] {
      background-color: ${theme.colors.primary.main}15 !important;
    }
  }

  .MuiChip-root {
    font-size: ${theme.typography.fontSize.xs};
    height: auto;
    border-radius: ${theme.borderRadius.sm};
  }

  .MuiAutocomplete-clearIndicator,
  .MuiAutocomplete-popupIndicator {
    color: ${theme.colors.gray[500]};

    &:hover {
      background-color: ${theme.colors.gray[100]};
    }
  }
`;
